export const formatMinutesSecondsToHours = (n) => {
  const hours = Math.trunc(n / 60)
    .toString()
    .padStart(2, '0');
  const minutes = Math.round(n % 60)
    .toString()
    .padStart(2, '0');
  return `${hours}:${minutes}:00`;
};
